(() => {
  const init = (root) => {
    if (!root || root.dataset.cqcReady === 'true') return;
    root.dataset.cqcReady = 'true';
    const toggle = root.querySelector('.cqc-hdr__mobile-toggle');
    const drawer = root.querySelector('.cqc-drawer');
    const overlay = root.querySelector('.cqc-drawer-overlay');
    const close = root.querySelector('.cqc-drawer__close');
    const setDrawer = (open) => {
      if (!drawer || !overlay) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      overlay.hidden = !open;
      toggle?.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    toggle?.addEventListener('click', () => setDrawer(true));
    close?.addEventListener('click', () => setDrawer(false));
    overlay?.addEventListener('click', () => setDrawer(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setDrawer(false); });

    root.querySelectorAll('.has-mega').forEach((item) => {
      const trigger = item.querySelector('.cqc-hdr__link');
      trigger?.addEventListener('click', (e) => {
        if (window.matchMedia('(pointer:coarse)').matches && window.innerWidth > 1100 && !item.classList.contains('is-open')) {
          e.preventDefault();
          root.querySelectorAll('.has-mega.is-open').forEach(el => el.classList.remove('is-open'));
          item.classList.add('is-open');
        }
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.has-mega')) root.querySelectorAll('.has-mega.is-open').forEach(el => el.classList.remove('is-open'));
    });

    root.querySelectorAll('.cqc-dept-card[data-card-url]').forEach((card) => {
      const openCard = () => {
        const url = card.dataset.cardUrl;
        if (url) window.location.href = url;
      };

      card.addEventListener('click', (e) => {
        if (e.target.closest('a, button, input, select, textarea')) return;
        openCard();
      });

      card.addEventListener('keydown', (e) => {
        if (e.target !== card) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openCard();
        }
      });
    });

    const headerBar = root.querySelector('.cqc-hdr__bar');
    const updateScrollState = () => headerBar?.classList.toggle('is-scrolled', window.scrollY > 24);
    updateScrollState();
    window.addEventListener('scroll', updateScrollState, { passive: true });
    const searchWrap = root.querySelector('.cqc-hdr__search-wrap');
    const searchToggle = root.querySelector('.cqc-hdr__search-toggle');
    const searchPanel = root.querySelector('.cqc-search-panel');
    const searchClose = root.querySelector('.cqc-search-panel__close');
    const searchInput = root.querySelector('.cqc-search-panel input[type="search"]');
    let searchTimer;

    const setSearch = (open, focusInput = false) => {
      if (!headerBar || !searchPanel) return;
      clearTimeout(searchTimer);
      headerBar.classList.toggle('search-open', open);
      headerBar.classList.toggle('search-hover', open);
      searchPanel.setAttribute('aria-hidden', String(!open));
      searchToggle?.setAttribute('aria-expanded', String(open));
      if (open && focusInput) setTimeout(() => searchInput?.focus(), 80);
    };

    const delayedCloseSearch = () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        if (!searchPanel?.matches(':hover') && !searchWrap?.matches(':hover')) setSearch(false);
      }, 180);
    };

    searchWrap?.addEventListener('mouseenter', () => {
      if (window.innerWidth > 1100) setSearch(true);
    });
    searchWrap?.addEventListener('mouseleave', delayedCloseSearch);
    searchPanel?.addEventListener('mouseenter', () => clearTimeout(searchTimer));
    searchPanel?.addEventListener('mouseleave', delayedCloseSearch);
    searchToggle?.addEventListener('click', () => {
      const willOpen = !headerBar?.classList.contains('search-open');
      setSearch(willOpen, willOpen);
    });
    searchClose?.addEventListener('click', () => setSearch(false));
  };
  const initAll = () => document.querySelectorAll('.cqc-hdr').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
